import classNames from 'classnames'
import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IIsInconsistencyPayload } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/models'
import React from 'react'

import styles from '../../..//Revenue.module.scss'
import { InconsistencyWrapper } from '../../../inconcistencyWrapper/InconsistencyWrapper'
import { useYearResultColumn } from '../../hooks/useYearResultColumn'
import { RenderFieldValue } from '../renderFieldValue/RenderFieldValue'

interface IProps {
  keyValue: TRevenueSnapshotKeys
  isInconsistency: (args: IIsInconsistencyPayload) => boolean
  yearField: keyof IRevenue
  quarterFields: (keyof IRevenue)[]
  value: string | number | undefined | null
}

export const FieldWithEnabledWarnings = ({
  keyValue,
  isInconsistency,
  yearField,
  value,
  quarterFields,
}: IProps) => {
  const { showWarningWrapper, warningMessages } = useYearResultColumn({
    keyValue,
    yearField,
    isInconsistency,
    quarterFields,
  })

  return (
    <InconsistencyWrapper warningMessages={warningMessages} showWarning={showWarningWrapper}>
      <RenderFieldValue
        value={value}
        keyValue={keyValue}
        classes={{ [classNames(styles.warning, styles.warningColumn)]: showWarningWrapper }}
      />
    </InconsistencyWrapper>
  )
}
